export var IdDoghouse;
(function (IdDoghouse) {
    IdDoghouse[IdDoghouse["GiveDogtreatCooldown"] = 3] = "GiveDogtreatCooldown";
})(IdDoghouse || (IdDoghouse = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdDoghouse.ts
// module id = 908
// module chunks = 3